export const PASSPORT = 0;
export const RESIDENCE = 1;
export const FOREIGN_PASSPORT = 2;

export const documentTypes = {
    [PASSPORT]: 'Паспорт РФ',
    [RESIDENCE]: 'Вид на жительство',
    [FOREIGN_PASSPORT]: 'Паспорт иностранного гражданина',
};